import { render, staticRenderFns } from "./ActivityList.vue?vue&type=template&id=5df972f6&scoped=true"
import script from "./ActivityList.vue?vue&type=script&lang=js"
export * from "./ActivityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df972f6",
  null
  
)

export default component.exports